import { colors } from 'config/themes/colors';
import styled, { createGlobalStyle } from 'styled-components';

export const POPUP_CLASS_NAME = 'top-result-activation-date-popup';

export const TopResultActivationDateStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  .label {
    font-weight: 600;
    color: ${({ theme }) => theme.text.primary};
  }

  .description {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.4;
    color: ${({ theme }) => theme.text.fadedGray};
  }

  .ant-picker {
    width: 100%;
  }
`;

export const TopResultActivationDatePopupStyles = createGlobalStyle`
  /* the project-wide picker styles force one text colour on every cell, so disabled days need their own */
  .${POPUP_CLASS_NAME} .ant-picker-cell-in-view.ant-picker-cell-disabled .ant-picker-cell-inner {
    color: ${({ theme }) => (theme.name === 'atsDark' ? colors.gray[600] : colors.gray[300])};
    cursor: not-allowed;
  }

  .${POPUP_CLASS_NAME} .ant-picker-cell-in-view.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner::before {
    border-color: ${({ theme }) => (theme.name === 'atsDark' ? colors.gray[600] : colors.gray[300])};
  }

  .${POPUP_CLASS_NAME} .ant-picker-cell-in-view .ant-picker-cell-inner.top-result-service-day {
    background: ${({ theme }) => (theme.name === 'atsDark' ? colors.blue[900] : colors.blue[100])} !important;
    color: ${({ theme }) => (theme.name === 'atsDark' ? colors.blue[200] : colors.blue[900])} !important;
    font-weight: 600;
  }

  .${POPUP_CLASS_NAME} .ant-picker-cell-in-view .ant-picker-cell-inner.top-result-service-day.top-result-service-start {
    background: ${({ theme }) => (theme.name === 'atsDark' ? colors.blue[600] : colors.blue[700])} !important;
    color: #fff !important;
  }

  .${POPUP_CLASS_NAME} .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner.top-result-muted-selection {
    background: transparent;
    color: ${({ theme }) => (theme.name === 'atsDark' ? theme.text.primary : colors.gray[900])};
  }

  .${POPUP_CLASS_NAME} .ant-picker-cell-in-view.ant-picker-cell-disabled .ant-picker-cell-inner.top-result-blocked-day {
    text-decoration: line-through;
  }
`;
